import type { App } from 'vue';
import type { LocaleMessages, VueMessageType } from 'vue-i18n';
import type { Router } from 'vue-router';

import {
  type LangCodes as DataLangCodes,
  languagesMap,
} from '@/data/languages';

export type LangCodes = DataLangCodes;

export interface IApp {
  vueApp: App;
  pageName: string;
  router: Router;
}

export interface IPageLang {
  langCode: LangCodes;
  pageName: string;
}

export type i18nMessage = Partial<
  Record<LangCodes, LocaleMessages<VueMessageType>>
>;

export type GetMsgFunction = (options: IPageLang) => Promise<i18nMessage>;

export function isLocaleAllowed(locale: string): locale is LangCodes {
  return locale in languagesMap;
}
